<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <h5 class="info-text">Empecemos con la información personal</h5>

        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="department"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>room</md-icon>
                <label>Departamento de residencia</label>
                <md-select
                  v-if="departments"
                  v-model="departmentId"
                  name="select"
                >
                  <md-option :value="null" disabled
                    >Seleccionar Departamento</md-option
                  >
                  <md-option
                    v-for="department in departments"
                    :key="department.id"
                    :value="department.id"
                    >{{ department.name }}</md-option
                  >
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="capCityResidence"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                v-if="department.cities"
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>room</md-icon>
                <label>Ciudad de residencia</label>
                <md-select v-model="capCityResidence" name="select">
                  <md-option
                    v-for="city in department.cities"
                    :key="city.id"
                    :value="city.id"
                    >{{ city.name }}</md-option
                  >
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>

          <AdressPicker
            class="md-layout-item md-size-100"
            @residenceAddress="fillAddress"
          />
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="timeLiving"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>room</md-icon>
                <label>¿Hace cuánto vive ahí? (años)</label>
                <md-select v-model="model.timeLiving" name="select">
                  <md-option :value="null" disabled>Seleccionar años</md-option>
                  <md-option :value="0">Menos de 1 año</md-option>
                  <md-option v-for="year in 4" :key="year" :value="year">{{
                    year
                  }}</md-option>
                  <md-option :value="5">Más de 4 años</md-option>
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_SOCIOECONOMIC_LEVEL }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainSocialELevel"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Estrato</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainSocialELevel"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >Estrato {{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_CIVIL_STATUS }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainCivilStatus"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Estado Civil</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainCivilStatus"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="numberPeopleInCharge"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>room</md-icon>
                <label>Cantidad de personas a su cargo</label>
                <md-select v-model="model.numberPeopleInCharge" name="select">
                  <md-option :value="null" disabled
                    >Seleccionar cantidad</md-option
                  >
                  <md-option :value="0">No respondo por nadie</md-option>
                  <md-option
                    v-for="people in 4"
                    :key="people"
                    :value="people"
                    >{{ people }}</md-option
                  >
                  <md-option :value="5">Más de 4 personas</md-option>
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="childrenNumber"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>room</md-icon>
                <label>Cantidad de hijos</label>
                <md-select v-model="model.childrenNumber" name="select">
                  <md-option :value="null" disabled
                    >Seleccionar cantidad</md-option
                  >
                  <md-option :value="0">0</md-option>
                  <md-option v-for="year in 4" :key="year" :value="year">{{
                    year
                  }}</md-option>
                  <md-option :value="5">Más de 4 hijos</md-option>
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <label class="md-layout-item md-size-15 md-form-label">
              Tiene tarjeta de crédito?
            </label>
            <div class="md-layout-item">
              <md-radio v-model="model.hasCredictCard" :value="1">Sí</md-radio>
              <md-radio v-model="model.hasCredictCard" :value="0">No</md-radio>
            </div>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_LIVE_WITH }"
            >
              <template v-slot="{ result: { data } }">
                <label class="md-layout-item md-size-15 md-form-label">
                  ¿Con quién vive?
                </label>
                <div v-if="data" class="md-layout">
                  <div class="md-layout-item md-size-20">
                    <md-checkbox v-model="liveAlone" @change="liveAloneChange"
                      >Solo</md-checkbox
                    >
                  </div>
                  <div class="md-layout-item md-size-80" v-if="!liveAlone">
                    <md-checkbox
                      v-for="(liveWith, i) in data.getDomain"
                      :key="liveWith.id"
                      v-model="capDomainsLiveWith[i]"
                      :value="liveWith.id"
                      >{{ liveWith.value }}</md-checkbox
                    >
                  </div>
                </div>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_VEHICLE_TYPE }"
            >
              <template v-slot="{ result: { data } }">
                <label class="md-layout-item md-size-15 md-form-label">
                  Tipo de vehículo
                </label>
                <div v-if="data" class="md-layout-item">
                  <md-radio
                    @change="vehicleTypeChange"
                    v-for="sex in data.getDomain"
                    :key="sex.id"
                    v-model="capDomainVehicleType"
                    :value="sex.id"
                    >{{ sex.value }}</md-radio
                  >
                </div>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-size-40 md-small-size-100">
            <ValidationProvider
              v-if="capDomainVehicleType && capDomainVehicleType != 171"
              name="vehiclePlate"
              rules="required|max:6|min:5"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>picture_in_picture_alt</md-icon>
                <label>Placa del vehículo</label>
                <md-input v-model="model.vehiclePlate" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="phoneNumber"
              rules="required|max_value:9999999|min_value:1000000"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>phone</md-icon>
                <label>Teléfono</label>
                <md-input v-model="model.phoneNumber" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import AdressPicker from "../../components/AdressPicker";
import { required, max, min } from "vee-validate/dist/rules";
import Swal from "sweetalert2";
import Constants from "../../../constants";
import gql from "graphql-tag";

extend("required", required);
extend("max", max);
extend("min", min);
export default {
  components: { AdressPicker },
  props: {
    registerImg: {
      type: String,
      default: "./img/card-1.jpg"
    },
    applyImg: {
      type: String,
      default: "./img/card-2.jpg"
    }
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query departments {
            departments {
              id: depId
              name: depName
              cities: capCities {
                id: cityId
                name: cityName
              }
            }
          }
        `
      })
      .then(data => {
        this.departments = data.data.departments;
      });
  },
  data() {
    return {
      modalAdress: false,
      liveAlone: false,
      departments: [],
      capDomainVehicleType: null,
      capDomainsLiveWith: [],
      liveWithRefactor: [],
      capDomainCivilStatus: null,
      capDomainSocialELevel: null,
      department: {},
      departmentId: null,
      capCityResidence: null,
      model: {
        hasCredictCard: null,
        timeLiving: null,
        residenceAddress: null,
        vehiclePlate: null
      },
      Constants: Constants
    };
  },
  methods: {
    fillAddress(value) {
      this.model.residenceAddress = value;
    },
    vehicleTypeChange() {
      if (this.capDomainVehicleType == 171) this.model.vehiclePlate = null;
    },
    liveAloneChange() {
      if (this.liveAlone) this.capDomainsLiveWith = [];
    },

    toggleMultiLevel() {
      this.multiLevel = !this.multiLevel;
    },
    toggleMultiLevel2() {
      this.multiLevel2 = !this.multiLevel2;
      this.multiLevel3 = false;
    },
    toggleMultiLevel3() {
      this.multiLevel3 = !this.multiLevel3;
      this.multiLevel2 = false;
    },
    validate() {
      if (!this.capDomainVehicleType) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides tu tipo de vehículo o marcar si no tienes",
          timer: 2000,
          showConfirmButton: false
        });
      } else if (this.model.hasCredictCard == null) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides responder si tienes tarjeta de crédito o no",
          timer: 2000,
          showConfirmButton: false
        });
      } else if (!this.model.residenceAddress) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides tu dirección de residencia",
          timer: 2000,
          showConfirmButton: false
        });
      } else if (!this.validateAlmost1LW()) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides diligenciar con quien vives",
          timer: 2000,
          showConfirmButton: false
        });
      } else
        return this.$refs.form.validate().then(res => {
          this.$emit(
            "on-validated",
            res,
            this.model,
            this.capDomainVehicleType,
            this.liveWithRefactor,
            this.capDomainCivilStatus,
            this.capDomainSocialELevel,
            this.capCityResidence
          );
          return res;
        });
    },

    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    validateAlmost1LW() {
      var hasLiveWith = false;
      var newList = [];
      for (let index = 0; index < this.capDomainsLiveWith.length; index++) {
        const element = this.capDomainsLiveWith[index];
        if (element) {
          hasLiveWith = true;
          newList.push(element);
        }
      }
      if (!hasLiveWith && this.liveAlone) hasLiveWith = true;
      this.liveWithRefactor = newList;
      return hasLiveWith;
    }
  },
  watch: {
    departmentId() {
      this.department = this.departments.filter(obj => {
        return obj.id === this.departmentId;
      })[0];
    }
  }
};
</script>
<style></style>
